import { PropsWithChildren } from 'react';
import { Dimensions, StyleSheet, View } from 'react-native';

import { tokens } from '@fhs/ui';

import { AuthHeader } from '../auth-header';

const styles = StyleSheet.create({
  container: {
    alignContent: 'center',
    alignSelf: 'center',
    backgroundColor: tokens.colors.$white,
    alignItems: 'center',
    width: 440,
    borderColor: tokens.colors.$black10,
    borderRadius: 16,
    borderWidth: 1,
    padding: 12,
    position: 'absolute',
  },
  content: {
    flex: 1,
    paddingVertical: 16,
    width: '85%',
  },
  floatingHeader: { position: 'absolute', top: 0 },
  header: { flex: 1, justifyContent: 'center', alignItems: 'center' },

  logo: { alignSelf: 'center', marginVertical: -40 },
});

const { height } = Dimensions.get('window');

export function AuthContainerDesktop({ children }: PropsWithChildren) {
  return (
    <View style={styles.header}>
      <View style={styles.floatingHeader}>
        <AuthHeader height={height / 2.25} />
      </View>
      <View style={styles.container}>
        <View style={styles.content}>{children}</View>
      </View>
    </View>
  );
}
